import React from "react";
import {List, ListItem} from "@mui/material";
import {FileMetadata} from "../../gen/api";
import GridPaper from "../ContentBox/GridPaper";
import FileDownload from "../Files/FileDownload";

type Props = {
  evaluationRoutines: FileMetadata[]
}

export default function EvaluationRoutines({evaluationRoutines}: Props) {
  return (
      <GridPaper title="Auswertungsroutinen">
        <List>
          {evaluationRoutines.map(routine =>
              <ListItem key={routine.id}>
                <FileDownload form={routine}/>
              </ListItem>)
          }
        </List>
      </GridPaper>
  );
}